import Vue from 'vue';
/* import {
  Button,
  ColorPicker,
  Dropdown,
  DropdownMenu,
  DropdownItem,
} from 'element-ui'; */
import ElementUI from 'element-ui';

/* Vue.use(Button);
Vue.use(ColorPicker);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem); */
Vue.use(ElementUI);
